exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-activity-design-inline[data-v-1528dd14]{min-width:0}.fts-activity-design-inline .activity-inline-display[data-v-1528dd14]{max-width:100%;display:inline-flex;align-items:center}", ""]);

// exports
